import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Surname from './Surname';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="header-logo-modern">
            S. <Surname />
          </Link>

          <button
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            ☰
          </button>

          <nav className={`header-nav ${mobileMenuOpen ? 'open' : ''}`}>
            <Link
              to="/"
              className={isActive('/')}
              onClick={() => setMobileMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/data-essays"
              className={
                location.pathname.startsWith('/data-essays') ? 'active' : ''
              }
              onClick={() => setMobileMenuOpen(false)}
            >
              Data Essays
            </Link>
            <Link
              to="/photography"
              className={isActive('/photography')}
              onClick={() => setMobileMenuOpen(false)}
            >
              Photography
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
